new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('#carousel-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    })

    $('.lateral-banners-carousel').slick({
        arrows       : false,
        dots         : false,
        infinite     : true,
        slidesToShow : 1,
        slidesToScroll : 1,
        speed        : 750,
        mobileFirst: true,
    });

    $('#carousel-category').slick({
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 6,
                }
            }
        ]
    })

    $('#widget-category').slick({
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 9,
                    slidesToScroll: 1,
                }
            }
        ]
    })

    // $('.product_list').slick({
    //     arrows: false,
    //     dots: false,
    //     infinite: false,
    //     mobileFirst: true,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     speed: 700,

    //     responsive: [
    //         {
    //             breakpoint: 577,
    //             settings: {
    //                 slidesToShow: 3,
    //             }
    //         },
    //         {
    //             breakpoint: 767,
    //             settings: {
    //                 slidesToShow: 3,
    //             }
    //         },
    //         {
    //             breakpoint: 991,
    //             settings: {
    //                 arrows: true,
    //                 dots: false,
    //                 slidesToShow: 4,
    //             }
    //         }
    //     ]
    // });

    $('.widget-shes-like__photos').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                }
            }
        ]
    });

    $('#carousel-brands').slick({
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 6,
                }
            }
        ]
    })

    $('#carousel-products-1, #carousel-products-2, #carousel-products-3').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                    arrows: true,
                }
            }
        ]
    });

    $('#carousel-products-1, #carousel-products-2, #carousel-products-3').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    }); 
})